import { render } from "./Bureaus.vue?vue&type=template&id=242b69e3"
import script from "./Bureaus.vue?vue&type=script&lang=js"
export * from "./Bureaus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__